export enum PairSource {
  QUICKSWAP = "QUICKSWAP",
  UNISWAPV2 = "UNISWAPV2",
  SUSHISWAP = "SUSHISWAP",
}
